<!-- Нижняя группа системных пунктов бокового меню. -->
<template>
  <ul class="nav-list">
    <!-- Интеграции -->
    <IntegrationsItem
      v-bind="itemProps('integrations')"
      @navigate="forwardNavigate"
      @middle-click="forwardMiddleClick"
      @context-menu="forwardContextMenu"
    />

    <!-- Журнал событий -->
    <ActivityLogItem
      v-bind="itemProps('activity_log')"
      @navigate="forwardNavigate"
      @middle-click="forwardMiddleClick"
      @context-menu="forwardContextMenu"
    />

    <!-- Настройки -->
    <SettingsItem
      v-bind="itemProps('settings')"
      @navigate="forwardNavigate"
      @middle-click="forwardMiddleClick"
      @context-menu="forwardContextMenu"
    />
  </ul>
</template>

<script>
import ActivityLogItem from "@/components/AppSidebar/items/ActivityLogItem.vue";
import IntegrationsItem from "@/components/AppSidebar/items/IntegrationsItem.vue";
import SettingsItem from "@/components/AppSidebar/items/SettingsItem.vue";

export default {
  name: "AppSidebarFooterItems",
  components: {
    ActivityLogItem,
    IntegrationsItem,
    SettingsItem,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    activeItem: {
      type: String,
      required: true,
    },
    canSeePage: {
      type: Function,
      required: true,
    },
    newBadgeEnabled: {
      type: Function,
      required: true,
    },
  },
  emits: ["navigate", "middle-click", "context-menu"],
  methods: {
    itemProps(itemKey) {
      return {
        collapsed: this.collapsed,
        activeItem: this.activeItem,
        canSeePage: this.canSeePage,
        showNewBadge: this.newBadgeEnabled(itemKey),
      };
    },

    forwardNavigate(event, routeName) {
      this.$emit("navigate", event, routeName);
    },

    forwardMiddleClick(event, routeName) {
      this.$emit("middle-click", event, routeName);
    },

    forwardContextMenu(event, routeName) {
      this.$emit("context-menu", event, routeName);
    },
  },
};
</script>
